import React from 'react';
import { Card, CardContent } from '../../ui/card';

export const STATUS_FLOW = ['Booked', 'Confirmed', 'In Progress', 'Service Finished', 'Admin Confirmed', 'Completed'];

export const STATUS_COLORS = {
  'Booked': 'bg-yellow-500',
  'Confirmed': 'bg-emerald-500',
  'In Progress': 'bg-blue-500',
  'Service Finished': 'bg-purple-500',
  'Admin Confirmed': 'bg-indigo-500',
  'Completed': 'bg-green-500',
  'Canceled': 'bg-red-500',
};

export const StatusTracker = ({ currentStatus }) => {
  const currentIdx = STATUS_FLOW.indexOf(currentStatus);
  return (
    <Card className="border-0 shadow-md mb-6" data-testid="status-tracker">
      <CardContent className="p-4">
        <div className="flex items-center gap-1 overflow-x-auto">
          {STATUS_FLOW.map((step, i) => {
            const active = i <= currentIdx;
            const isCurrent = step === currentStatus;
            return (
              <React.Fragment key={step}>
                {i > 0 && <div className={`h-0.5 flex-1 min-w-[20px] ${active ? 'bg-[#F56F05]' : 'bg-zinc-200'}`} />}
                <div className="flex flex-col items-center min-w-[80px]">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
                    isCurrent ? 'bg-[#F56F05] text-white ring-4 ring-orange-100' :
                    active ? 'bg-[#F56F05] text-white' : 'bg-zinc-200 text-zinc-500'
                  }`}>{i + 1}</div>
                  <p className={`text-[10px] mt-1 text-center font-medium ${isCurrent ? 'text-[#F56F05]' : active ? 'text-zinc-700' : 'text-zinc-400'}`}>
                    {step}
                  </p>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
